module.exports = __webpack_public_path__ + "../static/img/vrf_aware_logo.76f147a8.png";